import {Component, EventEmitter, input, Input, InputSignal, OnDestroy, OnInit, Output} from '@angular/core';
import {ButtonThemeEnum} from "../button/button-theme-enum";
import {ToastService} from "../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";

@Component({
    selector: 'yo-text-box',
    templateUrl: './text-box.component.html',
    styleUrls: ['./text-box.component.scss'],
    standalone: false
})
export class TextBoxComponent implements OnInit, OnDestroy {

  @Input() value: string = "";
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  placeholder: InputSignal<string> = input("");

  /**
   * Permet de rendre le texte non lisible lors de l'écriture / lecture
   */
  @Input() secret: boolean = false;

  /**
   * Permet d'afficher le bouton de copie dans le presse-papier
   */
  @Input() copy: boolean = false;

  /**
   * Nom de la propriété à se baser pour l'autocompletion
   */
  @Input() autoComplete: string = "off";

  @Output() onValueChanged = new EventEmitter();

  constructor(private toastSvc: ToastService) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  copyToClipBoard = async () => {
    navigator.clipboard.writeText(this.value).then(() => {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.INFO,"Copie dans le presse-papier effectuée", undefined, 1);
    });
  };

  onChange($event) {
    this.value = $event.target.value;
    this.onValueChanged.emit(this.value);
  }
}
